import { useModal } from "@/features/modal/ModalStackManager";
import DefaultInstance, { BASE_URL } from "@/instance/axios";
import { useMutation } from "@tanstack/react-query";
import axios, { RawAxiosResponseHeaders } from "axios";
import dayjs from "dayjs";
import saveAs from "file-saver";

const interportGetQuery = (file: File | undefined) =>
  DefaultInstance.interportImportPost({
    file: file,
  });

export const useInterportMutationQuery = (file: File | undefined) => {
  const { closeModal } = useModal();
  return useMutation(() => interportGetQuery(file), {
    onSuccess: () => {
      alert("성공적으로 업로드 되었습니다.");
      closeModal({});
    },
    onError: () => {
      alert("업로드에 실패했습니다.");
    },
  });
};

export const useInterportDownloadQuery = {
  inspectRecordDownload: (startDate: string, endDate: string) => {
    return axios
      .post<Blob>(
        `${BASE_URL}/interport/export`,
        {
          sheetIndex: 10,
          startDate,
          endDate,
        },
        {
          responseType: "blob",
          headers: {
            Authorization: "Bearer " + localStorage.getItem("authToken"),
            Accept:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, application/octet-stream",
          },
        },
      )
      .then((response) => {
        const finalName = `${dayjs(startDate).format("YYYYMMDD")}~${dayjs(endDate).format("YYYYMMDD")}_검사기록.xlsx`;

        const headers = response.headers as RawAxiosResponseHeaders;
        const rawType = headers["content-type"];
        const type =
          typeof rawType === "string"
            ? rawType
            : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        const blob =
          response.data instanceof Blob ? response.data : new Blob([response.data], { type });

        saveAs(blob, finalName);
      })
      .catch((error) => {
        console.error(error);
      });
  },
};
